import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import iconWpc from "./images/Dekoviga-decorativa.png";
import iconPvc from "./images/Dekosuelo.png";
import iconSpc from "./images/Dekoviga-decorativa.png";
import iconWall from "./images/Icons-Deko-2.svg";
import ProductImageGallery from "../components/products/ProductImageGallery";
import bannerImg from "./images/Slide.jpg";
import "./Home.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import MapWithSidebar from "../components/common/MapWithSidebar";
import "../i18n";

const importAll = (context) => context.keys().map(context);
const wpcImages = importAll(
  require.context("./images/WPC/producto", false, /\.(jpg|png|webp)$/)
);

const importAllPVC = (context) => context.keys().map(context);
const pvcImages = importAllPVC(
  require.context("./images/PVC/producto", false, /\.(jpg|png|webp)$/)
);

const importAllSPC = (context) => context.keys().map(context);
const spcImages = importAllSPC(
  require.context("./images/SPC/producto", false, /\.(jpg|png|webp)$/)
);

const importAllWall = (context) => context.keys().map(context);
const wallImages = importAllWall(
  require.context("./images/WALL/producto", false, /\.(jpg|png|webp)$/)
);

const importAllRoof = (context) => context.keys().map(context);
const roofImages = importAllRoof(
  require.context("./images/ROOF/Producto", false, /\.(jpg|png|webp)$/)
);

// Solo metadatos; los textos salen del i18n
const familiesMeta = [
  {
    key: "wpc",
    icon: iconWpc,
    catalogUrl: "https://flipbooks.gruposantamaria.cr/flipbook1",
    images: wpcImages,
  },
  {
    key: "pvc",
    icon: iconPvc,
    catalogUrl: "https://flipbooks.gruposantamaria.cr/flipbook1",
    images: pvcImages,
  },
  {
    key: "spc",
    icon: iconSpc,
    catalogUrl: "https://flipbooks.gruposantamaria.cr/flipbook1",
    images: spcImages,
  },
  {
    key: "dekowall",
    icon: iconWall,
    catalogUrl: "https://flipbooks.gruposantamaria.cr/flipbook1",
    images: wallImages,
  },
  {
    key: "dekoroof",
    icon: iconSpc,
    catalogUrl: "https://flipbooks.gruposantamaria.cr/flipbook1",
    images: roofImages,
  }
];

const Home = () => {
  const { t, i18n } = useTranslation();
  const [active, setActive] = useState(familiesMeta[0].key);
  const videoRef = useRef(null);

  useEffect(() => {
    document.title = t("meta.title");
  }, [t, i18n.language]);

  // Mantener el video corriendo siempre
  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;

    const tryPlay = () => {
      // muted + playsInline permiten autoplay en móvil
      v.muted = true;
      const p = v.play();
      if (p && typeof p.then === "function") p.catch(() => {});
    };

    tryPlay();

    const onVisibility = () => {
      if (!document.hidden) tryPlay();
    };
    const onPause = () => {
      if (v.ended) v.currentTime = 0;
      tryPlay();
    };

    v.addEventListener("pause", onPause);
    v.addEventListener("ended", onPause);
    document.addEventListener("visibilitychange", onVisibility);

    return () => {
      v.removeEventListener("pause", onPause);
      v.removeEventListener("ended", onPause);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, []);

  return (
    <div className="home-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-overlay"></div>

        {/* Reemplaza la imagen por el video */}
        <video
          ref={videoRef}
          className="hero-banner"
          src="https://gruposantamaria.cr/wp-content/uploads/2026/01/dekoweb-2.mp4"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          poster={bannerImg}
          controls={false}
          disablePictureInPicture
          controlsList="nodownload noplaybackrate noremoteplayback"
        />

        <div className="hero-content">
          <h1>
            <span className="hero-title-line">{t("hero.titleLine")}</span>
            <span className="hero-title-highlight">
              {t("hero.titleHighlight")}
            </span>
          </h1>
          <p className="hero-subtitle">{t("hero.subtitle")}</p>
          <button
            className="hero-cta-button"
            onClick={() =>
              window.open(
                "https://wa.me/50661686664?text=%C2%A1Buenas!%20Vengo%20del%20sitio%20web%20y%20quisiera%20m%C3%A1s%20informaci%C3%B3n%20por%20favor.%20",
                "_blank",
                "noopener,noreferrer"
              )
            }
          >
            <span>{t("hero.cta")}</span>
            <svg className="cta-icon" viewBox="0 0 24 24">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </section>

      {/* Info Section */}
      <section className="info-section">
        <div className="info-container">
          <div className="info-box">
            <div className="info-icon-wrapper">
              <svg className="info-icon" viewBox="0 0 24 24">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
              </svg>
            </div>
            <h2 className="info-title">
              <span className="info-title-highlight">
                {t("info.titleHighlight")}
              </span>
              <span className="info-title-main">{t("info.titleMain")}</span>
            </h2>
            <div className="info-divider"></div>
            <p className="info-text">{t("info.text")}</p>
            <div className="info-decoration"></div>
          </div>
        </div>
      </section>

      {/* WhatsApp FAB nítido */}
      <a
        href="https://wa.me/50661686664?text=¡Hola! Vengo de la web de DEKO, Me gustaría obtener más información."
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chatear por WhatsApp"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 16 16"
          fill="white"
        >
          <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
        </svg>
      </a>

      {/* Product Families */}
      <section className="families-section">
        <div className="families-container">
          {/* Tabs Navigation - ESTRUCTURA SIMPLE */}
          <div className="families-tabs">
            {familiesMeta.map((family) => (
              <button
                key={family.key}
                className={`tab-button ${
                  active === family.key ? "active" : ""
                }`}
                onClick={() => setActive(family.key)}
              >
                <img
                  src={family.icon}
                  alt={t(`families.${family.key}.label`)}
                  className="tab-icon"
                />
                <span>{t(`families.${family.key}.label`)}</span>
              </button>
            ))}
          </div>

          {/* Tab Content */}
          <div className="tab-content">
            {familiesMeta.map((family) => {
              if (active !== family.key) return null;
              const features = t(`families.${family.key}.features`, {
                returnObjects: true,
              });
              return (
                <div key={family.key} className="family-panel">
                  {/* Left Panel - Description */}
                  <div className="panel-left">
                    <h2 className="family-title">
                      {t(`families.${family.key}.label`)}
                    </h2>
                    <p className="family-description">
                      {t(`families.${family.key}.description`)}
                    </p>

                    <ul className="features-list">
                      {Array.isArray(features) &&
                        features.map((feature, index) => (
                          <li key={index}>
                            <strong>{feature}</strong>
                          </li>
                        ))}
                    </ul>

                    <div className="action-buttons">
                      <button
                        onClick={() =>
                          window.open("https://wa.me/50661686664", "_blank")
                        }
                        className="primary-button"
                      >
                        {t("actions.quote")}
                      </button>
                      <a href={family.catalogUrl} className="catalog-link">
                        {t("actions.downloadCatalog")}{" "}
                        <span className="icon">💬</span>
                      </a>
                    </div>
                  </div>
                  {/* Right Panel - Gallery */}
                  <div className="panel-right">
                    <div className="gallery-wrapper">
                      <ProductImageGallery images={family.images} />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-background">
          <div className="cta-overlay"></div>
        </div>
        <div className="cta-content">
          <h2 className="cta-title">{t("ctaSection.title")}</h2>
          <p className="cta-subtitle">{t("ctaSection.subtitle")}</p>
          <div className="cta-buttons">
            <a href="https://wa.me/50661686664" className="cta-button primary">
              {t("ctaSection.buttons.quote")}
              <svg className="cta-icon" viewBox="0 0 24 24">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
            <a
              href="https://flipbooks.gruposantamaria.cr/flipbook1"
              className="cta-button secondary"
            >
              {t("ctaSection.buttons.viewAll")}
            </a>
          </div>
        </div>
      </section>
      {/* Map Section 3l1z0nd0TP11i11a*/}
      <section className="map-section">
        <div className="section-header">
          <h2 className="section-title">
            <span className="title-decoration">{t("map.titlePrefix")}</span>
            <span className="title-highlight">{t("map.titleHighlight")}</span>
          </h2>
          <p className="section-subtitle">{t("map.subtitle")}</p>
          <div className="section-divider"></div>
        </div>
        <div className="map-container">
          <MapWithSidebar />
        </div>
        <div className="contact-cta">
          <p>{t("map.noBranchQ")}</p>
          <a href="https://wa.me/50661686664" className="contact-link">
            {t("map.contactUs")} <span className="link-arrow">→</span>
          </a>
        </div>
      </section>
      
    </div>
  );
};

export default Home;

/*Foto  de traventino*/
/*Foto de Pisos*/
/*Foto de vigas*/
/*Foto de Liso*/
/*Foto de DekoRoof */
/*Palabras de el nav*/
/*Incorporar deko roof*/

